import React, {
    useState,
    useEffect,
    useRef,
    useCallback,
    useLayoutEffect,
} from 'react'
import { Okpd2 } from '../../../../../Org/Handbook/types'
import { OrganizationInfo } from '../../../../../Org/Home/types'

import { Contract, ContractPosition } from '../../../../types'

import { CurrencyList, Okei } from '../../../../../Plans/Positions/Edit/types'

import {
    PerformanceContractDocPositionItem,
    PerformanceContractDocPositionDraft,
} from '../../../Performances/types'

import LoadingIcon from '../../../../../../../components/LoadingIcon'
import HoverTooltip from '../../../../../../../components/HoverTooltip'

import ContractPositionCountryOriginPopup from '../ContractPositionCountryOriginPopup'
import ContractPositionCountryManufacturerPopup from '../ContractPositionCountryManufacturerPopup'

import { NumericFormat } from 'react-number-format'
import ContractPositionEditPopup from '../ContractPositionEditPopup'

import { ContractPositionRowError } from '../../types'

const formatNumber = (num: number | string | null | undefined): string => {
    if (num === null || num === undefined) return '-' // Обрабатываем пустые значения

    const parsedNum = typeof num === 'number' ? num : parseFloat(num)

    if (isNaN(parsedNum)) {
        return '-' // Обрабатываем некорректные значения
    }

    return parsedNum
        .toFixed(2) // Два знака после запятой
        .replace(/\B(?=(\d{3})+(?!\d))/g, ' ') // Разделяем тысячные пробелами
        .replace('.', ',') // Заменяем точку на запятую
}

const roundMoney = (value: number): number => {
    return Math.round(value * 100) / 100
}

type Props = {
    theme: string
    contractPosition: ContractPosition
    currencyList: CurrencyList[]
    selected: boolean
    onClick: (ordinal: number) => void
    onRightClick: (ordinal: number) => void
    contract: Contract
    okeiList: Okei[]
    contractAction: boolean
    onPatch: (ordinalNumber: number, patch: Partial<ContractPosition>) => void
    onDelete: (ordinalNumber: number) => void
    orgData: OrganizationInfo | undefined
    errors?: ContractPositionRowError
}

const ContractPositionTableRow: React.FC<Props> = (props) => {
    const textareaRef = useRef<HTMLTextAreaElement>(null)

    const [
        contractPositionCountryOriginPopup,
        setContractPositionCountryOriginPopup,
    ] = useState<boolean>(false)
    const [
        contractPositionCountryManufacturerPopup,
        setContractPositionCountryManufacturerPopup,
    ] = useState<boolean>(false)

    const [contractPositionDeleteRowPopup, setContractPositionDeleteRowPopup] =
        useState<boolean>(false)

    const [contractPositionEditPopup, setContractPositionEditPopup] =
        useState<boolean>(false)

    useLayoutEffect(() => {
        const el = textareaRef.current
        if (!el) return
        el.style.height = 'auto'
        requestAnimationFrame(() => {
            el.style.height = `${el.scrollHeight + 2}px`
        })
    }, [props.contractPosition.contract_position_name])

    const handleContractPositionCountryOriginPopup = () => {
        setContractPositionCountryOriginPopup(
            !contractPositionCountryOriginPopup
        )
    }
    const handleContractPositionCountryManufacturerPopup = () => {
        setContractPositionCountryManufacturerPopup(
            !contractPositionCountryManufacturerPopup
        )
    }

    const handleContractPositionEditPopup = () => {
        setContractPositionEditPopup(!contractPositionEditPopup)
    }

    const handleContractPositionDeleteRowPopup = () => {
        setContractPositionDeleteRowPopup((prev) => !prev)
    }

    const errorClass = (hasError?: boolean): string => {
        return hasError ? 'border border-[#C15C5C]' : ''
    }

    return (
        <div className="flex flex-col w-full h-fit">
            {/* строка документа */}

            <div
                className={`flex flex-row gap-1 mx-1 rounded text-[11px] text-[#181818] dark:text-[#FFFFFF] items-start justify-center ${props.errors?.type_object_purchase || props.errors?.registry_type || props.errors?.reg_number || props.errors?.score || props.errors?.target_code || props.errors?.type_code || props.errors?.amount_of_budget_funds ? 'border border-[#C15C5C] py-1' : ''}`}
                onContextMenu={(e) => {
                    e.preventDefault() // Отключает стандартное контекстное меню
                }}
            >
                <fieldset
                    className="flex flex-row w-full gap-1 items-start justify-center"
                    disabled={props.contractAction}
                >
                    <div
                        className="flex w-8 h-full items-start justify-center text-center cursor-pointer "
                        onClick={() => {
                            if (props.contractAction == false) {
                                props.onClick(
                                    props.contractPosition.ordinal_number
                                )
                            }
                        }}
                    >
                        <HoverTooltip tooltipText="Выбрать строку">
                            <input
                                type="checkbox"
                                className="flex h-[28px] cursor-pointer"
                                checked={props.selected}
                                onClick={(e) => {
                                    e.stopPropagation()
                                    props.onClick(
                                        props.contractPosition.ordinal_number
                                    )
                                }}
                                readOnly
                            />
                        </HoverTooltip>
                    </div>
                    <div
                        className="flex w-10 h-full pt-1 items-start justify-center text-[#6A6A6A] dark:text-[#8A8A8A] cursor-pointer"
                        onClick={() => {
                            if (props.contractAction == false) {
                                props.onClick(
                                    props.contractPosition.ordinal_number
                                )
                            }
                        }}
                    >
                        {props.contractPosition.ordinal_number}
                    </div>
                    <div className="flex flex-1 items-center justify-start text-[#181818] dark:text-[#FFFFFF] ">
                        <HoverTooltip
                            tooltipContent={
                                props.contractPosition.contract_position_name
                            }
                            align="right"
                            valign="bottom"
                        >
                            <textarea
                                ref={textareaRef}
                                className={`form-textarea-table-row flex min-h-[26px] w-full p-1 px-2 rounded-md text-[11px] text-[#181818] dark:text-[#FFFFFF] bg-[#181818] ${errorClass(
                                    !!props.errors?.contract_position_name
                                )}`}
                                maxLength={2000}
                                value={
                                    props.contractPosition
                                        .contract_position_name
                                }
                                rows={1}
                                onChange={(e) => {
                                    props.onPatch(
                                        props.contractPosition.ordinal_number,
                                        {
                                            contract_position_name:
                                                e.target.value,
                                        }
                                    )
                                }}
                            />
                        </HoverTooltip>
                    </div>
                    <div
                        className={`relative flex w-[120px] text-[#181818] dark:text-[#FFFFFF] items-center justify-end`}
                    >
                        <HoverTooltip
                            tooltipContent={
                                props.contractPosition.country_of_origin != null
                                    ? props.contractPosition.country_of_origin.country.map(
                                          (c, index) => (
                                              <div key={index}>{c.name}</div>
                                          )
                                      )
                                    : '-'
                            }
                            valign="bottom"
                        >
                            <input
                                type="text"
                                className={`form-input-table-row flex pl-2 pr-9 w-full h-[28px] rounded-md text-[#181818] dark:text-[#FFFFFF] ${errorClass(
                                    !!props.errors?.country_of_origin
                                )}`}
                                value={
                                    props.contractPosition.country_of_origin
                                        ? props.contractPosition
                                              .country_of_origin?.country[0]
                                              .name +
                                          ` ${props.contractPosition.country_of_origin.country.length > 1 ? `(${props.contractPosition.country_of_origin.country.length})` : ''}`
                                        : ''
                                }
                                readOnly
                            />
                        </HoverTooltip>
                        <button
                            className="absolute flex w-6 h-6 mr-1 rounded-full items-center justify-center hover:bg-[#e4e6e8] dark:hover:bg-[#656365]"
                            onClick={handleContractPositionCountryOriginPopup}
                        >
                            {/* иконка */}
                            <svg
                                className="w-3 h-3"
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 24 24"
                                id="bars"
                            >
                                <path
                                    fill={
                                        props.theme == 'dark'
                                            ? '#FFFFFF'
                                            : '#181818'
                                    }
                                    d="M3,8H21a1,1,0,0,0,0-2H3A1,1,0,0,0,3,8Zm18,8H3a1,1,0,0,0,0,2H21a1,1,0,0,0,0-2Zm0-5H3a1,1,0,0,0,0,2H21a1,1,0,0,0,0-2Z"
                                ></path>
                            </svg>
                        </button>
                        {props.contractPosition.country_of_origin ? (
                            props.contractPosition.country_of_origin.country
                                .length > 1 ? (
                                <div className="absolute right-[-4px] top-[-7px] flex w-4 h-4 items-center justify-center text-center rounded-full bg-[#f6f6f6] dark:bg-[#494849] z-20">
                                    {
                                        props.contractPosition.country_of_origin
                                            .country.length
                                    }
                                </div>
                            ) : (
                                ''
                            )
                        ) : (
                            ''
                        )}
                    </div>
                    <div className="relative flex w-[120px] text-[#181818] dark:text-[#FFFFFF] items-center justify-end">
                        <HoverTooltip
                            tooltipText={
                                props.contractPosition.country_manufacturer !=
                                null
                                    ? String(
                                          props.contractPosition
                                              .country_manufacturer.name
                                      )
                                    : '-'
                            }
                            valign="bottom"
                        >
                            <input
                                type="text"
                                className={`form-input-table-row flex pl-2 pr-9 w-full h-[28px] rounded-md text-[#181818] dark:text-[#FFFFFF] ${errorClass(
                                    !!props.errors?.country_manufacturer
                                )}`}
                                value={
                                    props.contractPosition.country_manufacturer
                                        ?.name ?? ''
                                }
                                readOnly
                            />
                        </HoverTooltip>
                        <button
                            className="absolute flex w-6 h-6 mr-1 rounded-full items-center justify-center hover:bg-[#e4e6e8] dark:hover:bg-[#656365]"
                            onClick={
                                handleContractPositionCountryManufacturerPopup
                            }
                        >
                            {/* иконка */}
                            <svg
                                className="w-3 h-3"
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 24 24"
                                id="bars"
                            >
                                <path
                                    fill={
                                        props.theme == 'dark'
                                            ? '#FFFFFF'
                                            : '#181818'
                                    }
                                    d="M3,8H21a1,1,0,0,0,0-2H3A1,1,0,0,0,3,8Zm18,8H3a1,1,0,0,0,0,2H21a1,1,0,0,0,0-2Zm0-5H3a1,1,0,0,0,0,2H21a1,1,0,0,0,0-2Z"
                                ></path>
                            </svg>
                        </button>
                    </div>
                    <div className="flex flex-row h-7 w-7 items-center justify-center text-center">
                        <div
                            className={`flex w-6 h-6 rounded-full items-center justify-center hover:bg-[#FFFFFF] dark:hover:bg-[#656365]`}
                        >
                            <HoverTooltip tooltipText="Невозможно определить количество (объем)">
                                <input
                                    type="checkbox"
                                    checked={
                                        props.contractPosition
                                            .impossible_to_determine_attr
                                    }
                                    onChange={(e) => {
                                        props.onPatch(
                                            props.contractPosition
                                                .ordinal_number,
                                            {
                                                impossible_to_determine_attr:
                                                    e.target.checked,
                                            }
                                        )
                                    }}
                                />
                            </HoverTooltip>
                        </div>
                    </div>
                    <div className="flex w-32 items-center justify-center">
                        <NumericFormat
                            value={props.contractPosition.qty ?? ''}
                            // важное:
                            decimalSeparator=","
                            thousandSeparator=" "
                            allowNegative={false}
                            allowLeadingZeros={false}
                            // максимум 4 знака после запятой
                            decimalScale={4}
                            // при пустом значении не принудительно не добиваем нули
                            fixedDecimalScale={false}
                            // это заставит onValueChange.value быть С ТОЧКОЙ (канонично для бэка)
                            valueIsNumericString
                            // ввод из буфера с запятой/точкой работает:
                            onValueChange={(v) => {
                                props.onPatch(
                                    props.contractPosition.ordinal_number,
                                    {
                                        qty:
                                            v.value === ''
                                                ? null
                                                : Number(v.value),
                                    }
                                )
                            }}
                            // не даём вводить ничего кроме цифр, точки, запятой
                            isAllowed={(vals) => {
                                // react-number-format сам ограничит по decimalScale,
                                // но добавим запрет на NaN
                                if (vals.formattedValue === '') return true
                                return !Number.isNaN(vals.floatValue)
                            }}
                            className={`form-input-table-row rounded-md text-primary text-center w-full h-[28px] px-2 ${errorClass(
                                !!props.errors?.qty
                            )}`}
                            // Запрет стандартной прокрутки значения колесом
                            disabled={
                                props.contractPosition
                                    .impossible_to_determine_attr
                            }
                        />
                    </div>
                    <div className="flex flex-col w-32 items-center justify-center gap-1">
                        <HoverTooltip
                            tooltipText={
                                props.contractPosition.okei_code == null
                                    ? 'Выбрать'
                                    : String(props.contractPosition.okei_name)
                            }
                        >
                            <select
                                className={`form-input-table-row px-2 rounded-md w-full h-[28px] ${errorClass(
                                    !!props.errors?.okei_code
                                )}`}
                                value={props.contractPosition.okei_code ?? ''}
                                onChange={(e) => {
                                    const selectedCode = e.target.value
                                    const selectedOkei = props.okeiList.find(
                                        (okei) => okei.code === selectedCode
                                    )

                                    props.onPatch(
                                        props.contractPosition.ordinal_number,
                                        {
                                            okei_code:
                                                selectedOkei?.code ?? null,
                                            okei_name:
                                                selectedOkei?.name ?? null,
                                        }
                                    )
                                }}
                                disabled={
                                    props.contractPosition
                                        .impossible_to_determine_attr
                                }
                            >
                                {props.contractPosition
                                    .impossible_to_determine_attr ? (
                                    <option
                                        className="text-[#6A6A6A] dark:text-[#8A8A8A]"
                                        value=""
                                    ></option> // <-- пусто, когда impossible_to_determine_attr true (и в других твоих кейсах)
                                ) : (
                                    <option
                                        className="text-[#6A6A6A] dark:text-[#8A8A8A]"
                                        value=""
                                    >
                                        {props.contractPosition.okei_code ==
                                        null
                                            ? 'Выбрать'
                                            : ''}
                                    </option> // <-- обычный плейсхолдер
                                )}
                                {props.okeiList.map((item, index) => (
                                    <option key={index} value={item.code}>
                                        {item.name}
                                    </option>
                                ))}
                            </select>
                        </HoverTooltip>
                        {props.contract.currency_digital_code != 643 && (
                            <div className="flex flex-col gap-1 w-full items-end justify-center text-right h-7">
                                <div className="flex flex-col w-full">
                                    <label className="w-full text-[10px] text-[#6A6A6A] dark:text-[#8A8A8A]">
                                        Цена в рублях:
                                    </label>
                                </div>
                            </div>
                        )}
                    </div>
                    <div className="flex flex-col gap-1 w-32 items-center justify-center ">
                        <NumericFormat
                            value={formatNumber(
                                props.contractPosition.unit_price
                            )}
                            className={`form-input-table-row rounded-md text-primary w-full h-[28px] px-2 text-right ${errorClass(
                                !!props.errors?.unit_price
                            )}`}
                            allowNegative={false}
                            decimalScale={2}
                            fixedDecimalScale={true}
                            decimalSeparator=","
                            thousandSeparator=" "
                            placeholder="0,00"
                            disabled={false}
                            onValueChange={(v) => {
                                props.onPatch(
                                    props.contractPosition.ordinal_number,
                                    {
                                        unit_price:
                                            v.value === ''
                                                ? null
                                                : Number(v.value),
                                    }
                                )
                            }}
                        />
                        {props.contract.currency_digital_code != 643 && (
                            <div className="flex flex-col gap-1 w-full items-center justify-center h-fit">
                                <div className="flex flex-col w-full">
                                    <NumericFormat
                                        value={roundMoney(
                                            Number(
                                                props.contractPosition
                                                    .unit_price ?? 0
                                            ) *
                                                Number(
                                                    props.contractPosition
                                                        .exchange_rate ?? 1
                                                )
                                        )}
                                        className={`form-input-table-row rounded-md text-primary w-full h-[28px] px-2 text-right`}
                                        allowNegative={false}
                                        decimalScale={2}
                                        fixedDecimalScale={true}
                                        decimalSeparator=","
                                        thousandSeparator=" "
                                        placeholder="0,00"
                                        disabled={true}
                                    />
                                </div>
                            </div>
                        )}
                    </div>
                    <div className="flex flex-col gap-1 w-32 items-center justify-center ">
                        <NumericFormat
                            value={formatNumber(
                                Number(props.contractPosition.qty) *
                                    Number(props.contractPosition.unit_price)
                            )}
                            className={`form-input-table-row rounded-md text-primary w-full h-[28px] px-2 text-right`}
                            allowNegative={false}
                            decimalScale={2}
                            fixedDecimalScale={true}
                            decimalSeparator=","
                            thousandSeparator=" "
                            placeholder="0,00"
                            disabled={true}
                            onValueChange={(v) => {
                                const dotString = v.value ?? ''
                            }}
                        />
                        {props.contract.currency_digital_code != 643 && (
                            <div className="flex flex-col gap-1 w-full items-center justify-center h-fit">
                                <div className="flex flex-col w-full">
                                    <NumericFormat
                                        value={roundMoney(
                                            Number(
                                                props.contractPosition.qty ?? 0
                                            ) *
                                                Number(
                                                    props.contractPosition
                                                        .unit_price ?? 0
                                                ) *
                                                Number(
                                                    props.contractPosition
                                                        .exchange_rate ?? 1
                                                )
                                        )}
                                        className={`form-input-table-row rounded-md text-primary w-full h-[28px] px-2 text-right`}
                                        allowNegative={false}
                                        decimalScale={2}
                                        fixedDecimalScale={true}
                                        decimalSeparator=","
                                        thousandSeparator=" "
                                        placeholder="0,00"
                                        disabled={true}
                                    />
                                </div>
                            </div>
                        )}
                    </div>
                </fieldset>
                {props.contractAction ? (
                    <>
                        <div className="flex w-8 text-right items-center justify-center">
                            <HoverTooltip tooltipText="Открыть">
                                <button
                                    className="w-6 h-6 grid rounded-full items-center justify-center hover:bg-[#FFFFFF] dark:hover:bg-[#656365]"
                                    onClick={handleContractPositionEditPopup}
                                >
                                    <svg
                                        className="w-4 h-4"
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 24 24"
                                        id="edit-alt"
                                    >
                                        <path
                                            fill={
                                                props.theme == 'dark'
                                                    ? '#FFFFFF'
                                                    : '#181818'
                                            }
                                            d="M3,8H21a1,1,0,0,0,0-2H3A1,1,0,0,0,3,8Zm18,8H3a1,1,0,0,0,0,2H21a1,1,0,0,0,0-2Zm0-5H3a1,1,0,0,0,0,2H21a1,1,0,0,0,0-2Z"
                                        ></path>
                                    </svg>
                                </button>
                            </HoverTooltip>
                        </div>
                    </>
                ) : (
                    <>
                        <div className="flex w-8 text-right items-center justify-center">
                            <HoverTooltip tooltipText="Редактировать">
                                <button
                                    className="w-6 h-6 grid rounded-full items-center justify-center hover:bg-[#FFFFFF] dark:hover:bg-[#656365]"
                                    onClick={handleContractPositionEditPopup}
                                >
                                    <svg
                                        className="w-4 h-4"
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 24 24"
                                        id="edit-alt"
                                    >
                                        <path
                                            fill={
                                                props.theme == 'dark'
                                                    ? '#FFFFFF'
                                                    : '#181818'
                                            }
                                            d="M5,18H9.24a1,1,0,0,0,.71-.29l6.92-6.93h0L19.71,8a1,1,0,0,0,0-1.42L15.47,2.29a1,1,0,0,0-1.42,0L11.23,5.12h0L4.29,12.05a1,1,0,0,0-.29.71V17A1,1,0,0,0,5,18ZM14.76,4.41l2.83,2.83L16.17,8.66,13.34,5.83ZM6,13.17l5.93-5.93,2.83,2.83L8.83,16H6ZM21,20H3a1,1,0,0,0,0,2H21a1,1,0,0,0,0-2Z"
                                        ></path>
                                    </svg>
                                </button>
                            </HoverTooltip>
                        </div>
                        <div className="flex w-8 text-right items-center justify-center">
                            <HoverTooltip tooltipText="Удалить">
                                <button
                                    className=" flex w-6 h-6 rounded-full items-center justify-center hover:bg-[#ed9cae] dark:hover:bg-[#701f1f]"
                                    onClick={
                                        handleContractPositionDeleteRowPopup
                                    }
                                >
                                    <svg
                                        className="w-4 h-4"
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 24 24"
                                        id="trash-alt"
                                    >
                                        <path
                                            fill={
                                                props.theme == 'dark'
                                                    ? '#FFFFFF'
                                                    : '#181818'
                                            }
                                            d="M10,18a1,1,0,0,0,1-1V11a1,1,0,0,0-2,0v6A1,1,0,0,0,10,18ZM20,6H16V5a3,3,0,0,0-3-3H11A3,3,0,0,0,8,5V6H4A1,1,0,0,0,4,8H5V19a3,3,0,0,0,3,3h8a3,3,0,0,0,3-3V8h1a1,1,0,0,0,0-2ZM10,5a1,1,0,0,1,1-1h2a1,1,0,0,1,1,1V6H10Zm7,14a1,1,0,0,1-1,1H8a1,1,0,0,1-1-1V8H17Zm-3-1a1,1,0,0,0,1-1V11a1,1,0,0,0-2,0v6A1,1,0,0,0,14,18Z"
                                        ></path>
                                    </svg>
                                </button>
                            </HoverTooltip>
                        </div>
                    </>
                )}
            </div>

            {contractPositionCountryOriginPopup && (
                <ContractPositionCountryOriginPopup
                    theme={props.theme}
                    contractPositionGuid={props.contractPosition.guid ?? ''}
                    contractPosition={props.contractPosition}
                    handleContractPositionCountryOriginPopup={
                        handleContractPositionCountryOriginPopup
                    }
                    onSave={(country_of_origin) => {
                        props.onPatch(props.contractPosition.ordinal_number, {
                            country_of_origin,
                        })
                        handleContractPositionCountryOriginPopup()
                    }}
                />
            )}
            {contractPositionCountryManufacturerPopup && (
                <ContractPositionCountryManufacturerPopup
                    theme={props.theme}
                    contractPositionGuid={props.contractPosition.guid ?? ''}
                    contractPosition={props.contractPosition}
                    handleContractPositionCountryManufacturerPopup={
                        handleContractPositionCountryManufacturerPopup
                    }
                    onSave={(country_manufacturer) => {
                        props.onPatch(props.contractPosition.ordinal_number, {
                            country_manufacturer,
                        })
                        handleContractPositionCountryManufacturerPopup()
                    }}
                />
            )}
            {contractPositionEditPopup && (
                <ContractPositionEditPopup
                    theme={props.theme}
                    contractPositionGuid={props.contractPosition.guid ?? ''}
                    contractPosition={props.contractPosition}
                    handleContractPositionEditPopup={
                        handleContractPositionEditPopup
                    }
                    handleContractPositionCountryOriginPopup={
                        handleContractPositionCountryOriginPopup
                    }
                    handleContractPositionCountryManufacturerPopup={
                        handleContractPositionCountryManufacturerPopup
                    }
                    okeiList={props.okeiList}
                    onSave={(patch) => {
                        props.onPatch(
                            props.contractPosition.ordinal_number,
                            patch
                        )
                        handleContractPositionEditPopup()
                    }}
                    orgData={props.orgData}
                    errors={props.errors}
                    contractAction={props.contractAction}
                />
            )}

            {/* delete popup */}
            {contractPositionDeleteRowPopup && (
                <div className="fixed top-0 left-0 w-full h-full bg-[#00000050] flex justify-center items-center z-50">
                    <div
                        className="p-5 rounded-lg bg-[#e5e5e5] dark:bg-[#262427] w-fit max-h-[600px]"
                        onClick={(e) => e.stopPropagation()}
                    >
                        <div className="flex flex-col text-sm text-[#181818] dark:text-[#FFFFFF] items-center justify-center gap-5">
                            <div className="flex flex-col">
                                <label className="flex mb-1 text-sm text-[#181818] dark:text-[#FFFFFF]">
                                    Удалить позицию?
                                </label>
                            </div>
                            <div className="flex w-full flex-row items-center justify-end gap-3">
                                <button
                                    className="flex flex-row min-w-[120px] h-6 px-4 rounded-[10px] justify-center items-center gap-2 text-xs shadow-md shadow-[#18181830] text-[#181818] dark:text-[#FFFFFF] bg-[#f6f6f6] dark:bg-[#494849] hover:bg-[#FFFFFF] dark:hover:bg-[#656365]"
                                    onClick={
                                        handleContractPositionDeleteRowPopup
                                    }
                                >
                                    Отмена
                                </button>
                                <button
                                    className="flex px-4 py-1 min-w-[120px] h-6 rounded-[10px] items-center justify-center text-xs shadow-md shadow-[#18181830] text-[#181818] bg-[#ed9cae] hover:bg-[#ffa7ba] dark:bg-[#701F1F] dark:hover:bg-[#9e2c2c] dark:text-[#FFFFFF]"
                                    onClick={() => {
                                        props.onDelete(
                                            props.contractPosition
                                                .ordinal_number
                                        )
                                        handleContractPositionDeleteRowPopup()
                                    }}
                                >
                                    Удалить
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    )
}

export default ContractPositionTableRow
